export default __webpack_public_path__ + "static/media/pumper2.ac52b05c.png";